const translations = {
	unitTest: "en_us_unit_test",
	welcome: "Welcome",

	signIn: "Sign In",
	language: "Language",
	signInRequired: "Sign In Required",
	signInRequiredDescription: "You need to sign in to access the admin panel.",

	selectTheme: "Select Theme",

	// Roles
	roles: {
		SUPER_ADMIN: "Super Admin",
		SUPPORT_ADMIN: "Support Admin",
		ANALYTICS_VIEWER: "Analytics Viewer",
		USER_MANAGER: "User Manager",
	},

	// Dashboard
	dashboard: {
		title: "Dashboard",
		kpis: {
			title: "Platform Overview",
			totalOrganizations: "Organizations",
			totalUsers: "Users",
		},
		activeSubscriptions: {
			title: "Active Subscriptions",
			subtitle: "Organizations by plan type",
			starter: "Starter",
			professional: "Professional",
			enterprise: "Enterprise",
			total: "Total",
		},
		revenueChart: {
			title: "Revenue Trend",
			subtitle: "Monthly revenue over the last 12 months",
			noData: "Revenue data not available",
		},
	},

	// Common
	common: {
		loading: "Loading...",
		cancel: "Cancel",
		save: "Save",
		back: "Back",
		goHome: "Go Home",
		retry: "Retry",
		error: "Error",
		errors: {
			generic: "Something went wrong. Please try again.",
		},
	},

	// Users
	users: {
		title: "Users",
		table: {
			email: "Email",
			name: "Name",
			role: "Role",
			status: "Status",
			createdAt: "Created At",
			actions: "Actions",
		},
		roles: {
			super_admin: "Super Admin",
			support_admin: "Support Admin",
			analytics_viewer: "Analytics Viewer",
			user_manager: "User Manager",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		empty: {
			title: "No users found",
			description: "There are no users to display.",
		},
		editRole: {
			title: "Edit User Role",
			description: "Change the role for {{email}}",
			selectRole: "Select Role",
		},
		toasts: {
			updatingRole: "Updating user role...",
			updateRoleSuccess: "User role updated successfully",
			updateRoleError: "Failed to update user role",
		},
	},

	// Organizations
	organizations: {
		title: "Organizations",
		table: {
			name: "Name",
			description: "Description",
			language: "Language",
			currency: "Currency",
			trialAvailable: "Trial Available",
			createdAt: "Created At",
		},
		trial: {
			yes: "Yes",
			no: "No",
		},
		empty: {
			title: "No organizations found",
			description: "There are no organizations to display.",
		},
		details: {
			title: "Organization Details",
			description: "View and manage organization information",
			overview: {
				title: "Overview",
				description: "Organization overview and key information",
			},
			owner: {
				title: "Owner",
				description: "Organization owner information",
				noOwner: "No owner assigned",
			},
			info: {
				name: "Name",
				description: "Description",
				language: "Default Language",
				currency: "Default Currency",
				trialAvailable: "Trial Available",
				platformCustomerId: "Platform Customer ID",
				createdAt: "Created At",
				updatedAt: "Updated At",
				noDescription: "No description available",
			},
		},
		navigation: {
			overview: "Overview",
		},
		actions: {
			resetTrial: "Reset Trial",
		},
		toasts: {
			resettingTrial: "Resetting trial...",
			resetTrialSuccess: "Trial reset successfully",
			resetTrialError: "Failed to reset trial",
		},
	},

	// Support Tickets
	supportTickets: {
		title: "Support Tickets",
		ticketId: "Ticket ID",
		ticketInformation: "Ticket Information",
		description: "Description",
		comments: "Comments",
		noComments: "No comments yet",
		addComment: "Add Comment",
		commentPlaceholder: "Write your comment here...",
		sendComment: "Send Comment",
		commentSubmitting: "Sending...",
		addingComment: "Adding comment...",
		commentAdded: "Comment added successfully!",
		commentError: "Error adding comment. Please try again.",
		staff: "Staff",
		staffTeam: "Support Team",
		user: "User",
		table: {
			title: "Title",
			user: "User",
			type: "Type",
			status: "Status",
			createdAt: "Created At",
		},
		types: {
			suggestion: "Suggestion",
			request: "Request",
			complaint: "Complaint",
		},
		statuses: {
			open: "Open",
			waiting_for_user: "Waiting for User",
			waiting_for_staff: "Waiting for Staff",
			resolved: "Resolved",
			closed: "Closed",
		},
		empty: {
			title: "No support tickets found",
			description: "There are no support tickets to display.",
		},
	},

	// Settings
	settings: {
		title: "Settings",
		description: "Manage platform settings",
		navigation: {
			adminUsers: "Admin Users",
		},
		adminUsers: {
			empty: {
				title: "No admin users found",
				description: "There are no admin users to display.",
			},
		},
	},
	platformPlans: {
		title: "Platform Plans",
		list: {
			create: "Create plan",
			showArchived: "Show archived",
		},
		new: {
			title: "New platform plan",
		},
		detail: {
			formTitle: "Plan details",
			archive: "Archive plan",
			subscriptionsInfo:
				"This plan has {{count}} active subscription(s). It cannot be archived until all subscriptions move to another plan.",
			archiveDialog: {
				title: "Archive plan",
				description:
					'Are you sure you want to archive "{{name}}"? Archived plans are hidden from new sign-ups but existing subscriptions are preserved.',
			},
		},
		empty: {
			title: "No platform plans found",
			description: "Create your first platform plan to get started.",
		},
		status: {
			active: "Active",
			archived: "Archived",
		},
		table: {
			name: "Name",
			slug: "Slug",
			tier: "Tier",
			monthly: "Monthly",
			yearly: "Yearly",
			status: "Status",
			subscriptions: "Subs",
			defaultBadge: "Default",
		},
		form: {
			name: "Name",
			slug: "Slug",
			slugHint:
				"Lowercase letters, numbers, and hyphens. Cannot be changed after creation.",
			tier: "Tier",
			description: "Description",
			currency: "Currency",
			monthly: "Monthly price (cents)",
			yearly: "Yearly price (cents)",
			priceHint: "Prices are stored in the smallest currency unit (cents).",
			trialDays: "Trial days",
			isActive: "Active",
			isDefault: "Default plan",
			providerPriceIds: "Provider price IDs",
			providerPriceIdsEmpty:
				"No provider price IDs configured. Add one to link this plan to a payment provider.",
			providerPlaceholder: "stripe",
			cyclePlaceholder: "monthly",
			priceIdPlaceholder: "price_xxx",
			addPriceId: "Add price ID",
			submitCreate: "Create plan",
			submitUpdate: "Save changes",
			errors: {
				nameRequired: "Name is required",
				slugInvalid:
					"Slug must be lowercase alphanumeric, with optional hyphens",
				monthlyInvalid: "Monthly price must be a non-negative integer",
				yearlyInvalid: "Yearly price must be a non-negative integer",
				trialInvalid: "Trial days must be a non-negative integer",
				tierInvalid: "Tier must be an integer",
			},
		},
		entitlements: {
			title: "Entitlements",
			feature: "Feature",
			enabled: "Enabled",
			limitType: "Limit type",
			limitValue: "Limit value",
			save: "Save entitlements",
			limitTypes: {
				BOOLEAN: "Boolean",
				QUANTITY: "Quantity",
				UNLIMITED: "Unlimited",
			},
			errors: {
				quantityRequired:
					"A non-negative quantity is required for feature {{code}}",
			},
		},
		featureCodes: {
			medical_records: "Medical records",
			customer_import: "Customer import",
			analytics_dashboard: "Analytics dashboard",
			custom_branding: "Custom branding",
			priority_support: "Priority support",
			max_establishments: "Max establishments",
			max_staff_members: "Max staff members",
			max_customers: "Max customers",
			max_schedules_per_month: "Max schedules per month",
			llm_access: "LLM access",
			llm_tokens_per_month: "LLM tokens per month",
		},
		toasts: {
			creating: "Creating plan...",
			createSuccess: "Plan created",
			createError: "Failed to create plan",
			updating: "Saving plan...",
			updateSuccess: "Plan saved",
			updateError: "Failed to save plan",
			archiving: "Archiving plan...",
			archiveSuccess: "Plan archived",
			archiveError: "Failed to archive plan",
			savingEntitlements: "Saving entitlements...",
			saveEntitlementsSuccess: "Entitlements saved",
			saveEntitlementsError: "Failed to save entitlements",
		},
	},
};

export default translations;
